import React, {useEffect} from 'react';
import useSelectedProduct from '@views/orders/fields/products/useSelectedProduct';
import useFormValue from '@src/hooks/useFormValue';

export default function TechProcessTabVisibilityManager(props: {
    tabName: string,
    productNamePrefix: string,
    toggleTabVisibility: (tabName: string, shouldBeVisible: boolean) => void,
    children: React.ReactNode,
}) {
    const {productNamePrefix, tabName, toggleTabVisibility} = props;
    const {currentValue: orderProductId} = useFormValue(`${productNamePrefix}.id`);
    const activeProduct = useSelectedProduct(productNamePrefix);
    const productHasTechProcess = orderProductId != null && Boolean(activeProduct?.tech_processes?.length);

    useEffect(() => {
        toggleTabVisibility(tabName, productHasTechProcess);
    }, [productHasTechProcess, tabName, toggleTabVisibility]);

    return <>
        {props.children}
    </>;
}
